import { Theme } from "@mui/material";
import { getInputOverrides } from "./inputs";
import { getButtonOverrides } from "./buttons";
import { getDisplayOverrides } from "./displays";
import { getMiscOverrides } from "./misc";

export const getComponentOverrides = (theme: Theme) => {
  return Object.assign(
    {},
    getInputOverrides(theme),
    getButtonOverrides(theme),
    getDisplayOverrides(theme),
    getMiscOverrides(theme)
  );
};
